import type { CTAGrid } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import { camelCase } from 'lodash';
import React from 'react';

import { CMSCTA } from '@swf/cms';

import styles from './CMSCTAGrid.scss';

const CMSCTAGrid: React.FC<CTAGrid> = ({ variant, ctas }) =>
  ctas.length ? (
    <div
      className={classNames(
        styles.container,
        styles[camelCase(variant ?? 'inline') as keyof typeof styles]
      )}
    >
      {ctas.map((props) => (
        <CMSCTA {...props} key={props.title} />
      ))}
    </div>
  ) : null;

export default CMSCTAGrid;
